import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { audioHighlightToDecorationSpec } from './sceneCommentMapping';

export const REFRESH_AUDIO_HIGHLIGHT = 'refreshAudioHighlight';
const pluginKey = new PluginKey('audioHighlightDecorations');

const buildDecorations = (doc, options) => {
  const range = audioHighlightToDecorationSpec(
    doc,
    options.getAnchor(),
    options.sceneId
  );
  if (!range) return DecorationSet.empty;
  return DecorationSet.create(doc, [
    Decoration.inline(range.from, range.to, {
      class: options.getAnchor()?.fading
        ? 'br-audio-current-text br-audio-current-text--fading'
        : 'br-audio-current-text',
      'data-audio-current': 'true',
    }),
  ]);
};

export function AudioHighlightDecorations(options) {
  const resolved = {
    sceneId: options.sceneId,
    getAnchor: options.getAnchor || (() => null),
  };

  return Extension.create({
    name: 'audioHighlightDecorations',
    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: pluginKey,
          state: {
            init: (_config, state) => buildDecorations(state.doc, resolved),
            apply: (tr, old) => {
              if (tr.getMeta(REFRESH_AUDIO_HIGHLIGHT)) {
                return buildDecorations(tr.doc, resolved);
              }
              return tr.docChanged ? old.map(tr.mapping, tr.doc) : old;
            },
          },
          props: {
            decorations(state) {
              return pluginKey.getState(state);
            },
          },
        }),
      ];
    },
  });
}
